import React, { Component, PropTypes } from 'react';
import shouldPureComponentUpdate from 'react-pure-render/function';
import { Link } from 'react-router';
import LinkSubPage from 'components/LinkSubPage/LinkSubPage';
import './LinkButton.scss';

class LinkButton extends Component {
  static propTypes = {
    isExternal: PropTypes.bool,
    isDisabled: PropTypes.bool,
    hasWrapper: PropTypes.bool,
    to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    children: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    color: PropTypes.oneOf(['blue', 'blue-color-only']),
    type: PropTypes.oneOf(['primary', 'secondary', 'smaller-default', 'chevrons-on-left', 'toggle-up', 'toggle-down']),
    size: PropTypes.oneOf(['small', 'medium']),
    onClick: PropTypes.func,
    align: PropTypes.string,
    isSubPage: PropTypes.bool,
    location: PropTypes.object,
  };

  static defaultProps = {
    onClick: () => true,
    to: '#',
  };

  state = {
    tapped: '',
  };

  shouldComponentUpdate = shouldPureComponentUpdate;

  touchStart = () => {
    this.setState({
      tapped: 'tapped',
    });
  };

  touchEnd = () => {
    this.setState({
      tapped: '',
    });
  };

  render() {
    const {
      to,
      isExternal,
      children,
      color,
      onClick,
      type,
      size,
      align,
      isSubPage,
      location,
    } = this.props;

    const className = `link-button link-button--${type || 'default'}
      ${this.state.tapped ? `link-button--${this.state.tapped}` : ''}
      ${size ? `link-button--${size}` : ''}
      ${align ? `link-button--${align}-align` : ''}
      ${color ? `link-button--${color}` : ''}`;

    let link;

    if (this.props.isDisabled) {
      link = (
        <div className={`${className} link-button--is-disabled`} data-optimizely-id="LinkButton">
          { children }
        </div>
      );
    } else if (isExternal) {
      link = (
        <a
          href={to}
          className={className}
          onTouchStart={this.touchStart}
          onTouchEnd={this.touchEnd}
          onClick={onClick}
          data-optimizely-id="Link"
        >
          { children }
        </a>
      );
    } else if (isSubPage) {
      link = (
        <LinkSubPage
          to={to}
          location={location}
          className={className}
          onTouchStart={this.touchStart}
          onTouchEnd={this.touchEnd}
          onClick={onClick}
          data-optimizely-id="Link"
        >
          { children }
        </LinkSubPage>
      );
    } else {
      link = (
        <Link
          to={to}
          className={className}
          onTouchStart={this.touchStart}
          onTouchEnd={this.touchEnd}
          onClick={onClick}
          data-optimizely-id="Link"
        >
          { children }
        </Link>
      );
    }

    return this.props.hasWrapper ?
    (
      <div className="link-button__wrapper">
        {link}
      </div>
    ) :
    link;
  }
}

export default LinkButton;



/** WEBPACK FOOTER **
 ** ./src/components/LinkButton/LinkButton.jsx
 **/